export default {
  isMobile: false,
  loading: {
    show: false,
  },
  toast: {
    show: false,
    message: null,
    type: 'success',
    sentryTransactionId: null,
    timeout: 2500,
  },
  modalPermission: {
    show: false,
  },
};
